import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { MetricCardProps } from "@/types/types";
import { Progress } from "./ui/progress";

const MetricCard = ({
  title,
  value,
  iconLeft,
  iconRight,
  valueDescription,
  trend,
  progress,
  className = "",
  testId,
}: MetricCardProps) => (
  <Card className={cn("w-full", className)} data-testid={testId}>
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle
        className={cn(
          "text-muted-foreground flex w-full items-center gap-1 text-sm font-medium",
          iconRight ? "justify-between" : "justify-start"
        )}
      >
        {iconLeft && <span className="mr-1">{iconLeft}</span>}
        {title}
        {iconRight && <span>{iconRight}</span>}
      </CardTitle>
    </CardHeader>
    <CardContent>
      {/* Value and trend on the same row — matches design */}
      <div className="flex items-baseline gap-2">
        {value && <div className="text-2xl font-bold">{value}</div>}
        {trend && (
          <p
            className={cn(
              "flex items-center text-xs font-medium",
              trend.color && "text-green-500"
            )}
          >
            {trend.icon && <span className="mr-0.5">{trend.icon}</span>}
            {trend.value}
          </p>
        )}
      </div>

      {valueDescription && (
        <div className="text-muted-foreground mt-1 text-xs">
          {valueDescription}
        </div>
      )}

      {trend?.description && (
        <span className="text-muted-foreground text-xs">
          {trend.description}
        </span>
      )}

      {progress && (
        <div className="mt-2">
          <Progress value={progress.value} max={100} />
          {progress.label && (
            <div className="text-muted-foreground mt-1 text-xs">
              {progress.label}
            </div>
          )}
        </div>
      )}
    </CardContent>
  </Card>
);

export default MetricCard;
